import React, { useEffect, useState } from 'react'
import IndustriesImageContainer from './../../components/IndustriesImageContainer';
import Footer from '../../components/Footer';
import Navbar from '../../components/Navbar';
import filter_color from "../../assets/images/design/colorFilter.svg"
import { DoubleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs';
import { useTranslation } from 'react-i18next';
import { PrimaryButton } from '../../components/StyledButtons';
import location from "../../assets/images/icons/location-20px.svg"
import phone from "../../assets/images/icons/phone-20px.svg"
import mail from "../../assets/images/icons/mail-20px.svg"
import { StyledLink } from '../../components/StyledComponents';
import LoadingSpinner from '../../components/LoadingSpinner';
import { toast, ToastContainer } from 'react-toastify';
import instance from './../../axios/axiosConfig';

const Contact = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isValid, setIsValid] = useState(false)

  const successNotify = () => toast.success(t('notifycation.success'), {
    position: "bottom-right"
  });

  const failedNotify = () => toast.error(t('notifycation.failed'), {
    position: "bottom-right"
  });

  useEffect(() => {
    if (isLoading === true) {
      document.body.style.overflow = "hidden";
    }
    else {
      document.body.style.overflow = "auto";
    }
  }, [isLoading])

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    website: '',
    phoneNumber: '',
    message: ''
  });

  const [validationMessages, setValidationMessages] = useState({
    fullName: '',
    email: '',
    phoneNumber: '',
  });

  useEffect(() => {
    const phoneRegex = /^\+?84\s*[0-9]{4,}$|^[0-9]{6,}$/;
    const { fullName, email, phoneNumber } = formData;
    const isFullNameValid = fullName.trim() !== '';
    const isPhoneNumberValid = phoneNumber.trim() === "" || phoneRegex.test(phoneNumber.trim())
    const isEmailValid = email.trim() !== '';
    const isFormDataValid = isFullNameValid && isEmailValid && isPhoneNumberValid;
    const isValidationMessagesEmpty = Object.values(validationMessages).every(message => message === '');
    if (isFormDataValid && isValidationMessagesEmpty) {
      setIsValid(true)
    }
    else {
      setIsValid(false)
    }
    // if(Object.values(formData).every((value) => value !== '') &&
    // Object.values(validationMessages).every((message) => message === '')){
    //   setIsValid(true)
    // }
    // else{
    //   setIsValid(false)
    // }
  }, [formData, validationMessages])

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === 'fullName') {
      setValidationMessages((prevMessages) => ({
        ...prevMessages,
        fullName: value.trim() === '' ? t('validation.full-name-required') : '',
      }));
    }

    if (name === 'email') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value.trim() === "") {
        setValidationMessages(prevMessages => ({
          ...prevMessages,
          email: t('validation.email-required')
        }));
      } else if (!emailRegex.test(value.trim())) {
        setValidationMessages(prevMessages => ({
          ...prevMessages,
          email: t('validation.email-invalid')
        }));
      } else {
        setValidationMessages(prevMessages => ({
          ...prevMessages,
          email: ''
        }));
      }
    }

    if (name === 'phoneNumber') {
      const phoneRegex = /^\+?84\s*[0-9]{4,}$|^[0-9]{6,}$/;
      setValidationMessages((prevMessages) => ({
        ...prevMessages,
        phoneNumber: value.trim() === "" || phoneRegex.test(value.trim()) ? '' : t('validation.phone-invalid'),
      }));
    }
  }

  const handleSubmit = async (e) => {

    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\+?84\s*[0-9]{4,}$|^[0-9]{6,}$/;
    const newValidationMessages = {
      fullName: '',
      email: '',
      phoneNumber: '',
    };

    if (!formData.fullName.trim()) {
      newValidationMessages.fullName = t('validation.full-name-required');
    }

    if (!formData.email.trim()) {
      newValidationMessages.email = t('validation.email-required');
    } else if (!emailRegex.test(formData.email.trim())) {
      newValidationMessages.email = t('validation.email-invalid');
    }

    if (formData.phoneNumber.trim() !== "") {
      if (!phoneRegex.test(formData.phoneNumber.trim())) {
        newValidationMessages.phoneNumber = t('validation.phone-invalid');
      }
    }

    setValidationMessages(newValidationMessages);
    console.log("Ater", newValidationMessages)
    console.log(!Object.values(newValidationMessages).some((msg) => msg !== ''))
    if (!Object.values(newValidationMessages).some((msg) => msg !== '')) {
      const data = {
        fullName: formData.fullName,
        email: formData.email,
        message: formData.message,
        phoneNumber: formData.phoneNumber,
        website: formData.website,
        type: "Contact Page"
      };

      try {
        setIsLoading(true)
        console.log("Data", data)
        await instance.post('/sendContact', data)
          .then(function (response) {
            if (response.data === "success") {
              setIsLoading(false)
              successNotify()
              setFormData({
                fullName: '',
                email: '',
                message: '',
                website: '',
                phoneNumber: ''
              })
              setValidationMessages({
                fullName: '',
                email: '',
                phoneNumber: '',
              })
              newValidationMessages.email = ""
              newValidationMessages.fullName = ""
              newValidationMessages.phone = ""
            }
            else {
              setIsLoading(false)
              failedNotify()
            }
          })
          .catch(function (error) {
            console.log(error);
            setIsLoading(false)
            failedNotify()
          });

      } catch (error) {
        console.error('Error:', error);
        setIsLoading(false)
        failedNotify()
      } finally {
        setIsLoading(false)
      }
    }
  }

  const { t } = useTranslation()

  return (
    <div className='contact bg-primary'>
      <div className='color-filter-right' style={{ top: "40%" }}>
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <div className='color-filter-left' >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <Navbar />
      <div className='container-fluid contact-header pb-100'>
        <div className='container'>
          <div className='col-sm-10 col-sm-offset-1 pt-150'>
            <div className='font-weight-bold text-center font-64 healthcare-header-title'>{t('contact.title')}</div>
            <div className='col-sm-10 col-sm-offset-1'>
              <div className='underline-orange'></div>
            </div>
            <div className='col-sm-12 pt-20'>
              <p className='text-white text-center'>{t('contact.sub-title')}</p>
            </div>
          </div>
          <div className='col-sm-12 flex justify-center pt-50 px-0'>
            <DoubleCustomBreadCrumbs currentPage={t('bread-crumbs.contact-us')} />
          </div>
        </div>
      </div>
      <div className='contact-content container flex-lg align-center'>
        <div className='col-xl-w-600'>
          <div className='contact-info'>
            <p className='text-primary-orange font-weight-semi-bold uppercase'>{t('contact.content.contact-us')}</p>
            <p className='font-45 font-weight-semi-bold'>{t('contact.content.title')}</p>
            <p>{t('contact.content.content')}</p>
            <div className='flex align-start'>
              <img src={location} alt="" className='pt-5 mr-5' width="18" />
              <p className='pr-lg-50'>{t('contact.content.address')}</p>
            </div>
            <div className='flex align-start'>
              <img src={phone} alt="" className='pt-5 mr-5' width="18" />
              <p>1900 6884<br />
                +84 28 3622 2982</p>
            </div>
            <div className='flex align-start'>
              <img src={mail} alt="" className='pt-5 mr-5' width="18" />
              <StyledLink href="mailto:info@mobile-id.vn"><p className='text-primary'>info@mobile-id.vn</p></StyledLink>
            </div>
          </div>
        </div>
        <div className='col-xl-w--600'>
          <div className='contact-form'>
            <form onSubmit={handleSubmit}>
              <div className='row'>
                <div className='form-group-primary col-lg-6'>
                  <p className='font-weight-bold text-gray'>{t('modal.default-form.full-name')} <span style={{ color: "#FF3C00" }}>*</span></p>
                  <input type="text"
                    placeholder='John Carter'
                    className='form-control-primary mt-10'
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                  />
                  {validationMessages.fullName && <div className="errors--label">{validationMessages.fullName}</div>}
                </div>
                <div className='form-group-primary col-lg-6'>
                  <p className='font-weight-bold text-gray'>{t('modal.default-form.phone-number')}
                    {/* <span style={{ color: "#FF3C00" }}>*</span> */}
                  </p>
                  <input type="text"
                    placeholder='+84937776642'
                    className='form-control-primary mt-10'
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                  />
                  {validationMessages.phoneNumber && <div className="errors--label">{validationMessages.phoneNumber}</div>}
                </div>
                <div className='form-group-primary col-lg-6'>
                  <p className='font-weight-bold text-gray'>{t('modal.default-form.email')}
                    <span style={{ color: "#FF3C00" }}> *</span>
                  </p>
                  <input type="email"
                    placeholder='example@gmail.com'
                    className='form-control-primary mt-10'
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                  {validationMessages.email && <div className="errors--label">{validationMessages.email}</div>}
                </div>
                <div className='form-group-primary col-lg-6'>
                  <p className='font-weight-bold text-gray'>{t('modal.default-form.website')}
                    {/* <span style={{ color: "#FF3C00" }}>*</span> */}
                  </p>
                  <input type="text"
                    placeholder='https://www.mobile-id.vn/'
                    className='form-control-primary mt-10'
                    name="website"
                    value={formData.website}
                    onChange={handleInputChange}
                  />
                </div>
                <div className='form-group-primary col-lg-12'>
                  <p className='font-weight-bold text-gray'>{t('modal.default-form.message')}</p>
                  <textarea type="text"
                    placeholder={t('modal.default-form.type-message-here')}
                    className='form-control-primary mt-10'
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                  />
                </div>

                <div className='col-lg-12 pt-30 flex justify-center'>
                  <PrimaryButton type='submit' disabled={!isValid}>{t('button.send-message')}</PrimaryButton>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className='container'>
        <IndustriesImageContainer />
      </div>
      <Footer />
      {isLoading && <LoadingSpinner />}
      <ToastContainer />
    </div>
  )
}

export default Contact